import { AnimatePresence, motion } from "framer-motion";
import { useSettings } from "../hooks/useSettings";
import { easeOut } from "../motion";
import type { ThemeName } from "../theme";
import { IconMoon, IconSun } from "./icons";

/** Single topbar dark/light toggle. Accent swatches live on the Settings page. */
export function ThemeControls() {
  const { settings, update } = useSettings();
  if (!settings) return null;

  const next: ThemeName = settings.theme === "dark" ? "light" : "dark";
  const icon = settings.theme === "dark" ? <IconSun /> : <IconMoon />;

  return (
    <motion.button
      type="button"
      className="btn btn-icon btn-secondary"
      aria-label={next === "dark" ? "Switch to dark theme" : "Switch to light theme"}
      title={next === "dark" ? "Switch to dark theme" : "Switch to light theme"}
      onClick={() => update.mutate({ theme: next })}
      whileTap={{ scale: 0.9 }}
    >
      <AnimatePresence mode="wait" initial={false}>
        <motion.span
          key={settings.theme}
          className="theme-icon"
          style={{ display: "inline-flex" }}
          initial={{ opacity: 0, rotate: -90, scale: 0.5 }}
          animate={{ opacity: 1, rotate: 0, scale: 1 }}
          exit={{ opacity: 0, rotate: 90, scale: 0.5 }}
          transition={{ duration: 0.25, ease: easeOut }}
        >
          {icon}
        </motion.span>
      </AnimatePresence>
    </motion.button>
  );
}